// test1897
(1897 && 0);
